import '../../../styles/Modals.css'
import './UpdateEntityModals.css'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { ModalStates } from './UpdateEntityModalStates';

function UpdateEntityModalEditConfirmDataLine(props) {

  function getRowStyle() {
    // Show all rows when adding an entity.
    if (props.modalState === ModalStates.ConfirmAdd) {
      return 'null';
    }

    // When editing, only show if the value has changed.
    return props.originalParameter === props.updatedParameter ? 'InvisibleCollapse' : 'null';
  }

  return (
    <div className={getRowStyle()}>
      <Row className='AddEntityConfirmContainer'>
        <Col className={props.modalState === ModalStates.ConfirmAdd ? 'InvisibleCollapse' : 'null'}>
          <label className="AddEntityModalLabel">{props.label}</label>
          <br />
          {props.subtitle && <span className='secondary-text ms-1'>{props.subtitle}</span>}
        </Col>
        <Col>

          <label className="AddEntityModalLabel">{`NEW ${props.label}`}</label>
          <br />
          {props.subtitle && <span className='secondary-text ms-1'>{props.subtitle}</span>}

        </Col>
      </Row>
      <Row>
        <Col className={props.modalState === ModalStates.ConfirmAdd ? 'InvisibleCollapse' : 'null'}>
          <input className='AddEntityConfirmOriginal' readOnly value={(props.originalParameter ?? '') + (props.unit ? ` ${props.unit}` : '')} />
        </Col>
        <Col>
          <input className='AddEntityConfirmUpdated' readOnly value={(props.updatedParameter ?? '') + (props.unit ? ` ${props.unit}` : '')} />
        </Col>
      </Row>
    </div>
  );
}

export default UpdateEntityModalEditConfirmDataLine;